// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2qzdS","icon":"style_icon__y9zc1"};